export default "__VITE_ASSET__Bw1zNxT6__"